import { SET_SUPPLIER_HAS_DISCOUNTS } from "../Actions/supplierDiscountsActions";

const INITIAL_STATE = {
  hasDiscounts: false,
};

export const supplierDiscountsReducer = (state = INITIAL_STATE, action) => {
  const { payload } = action;
  switch (action.type) {
    case SET_SUPPLIER_HAS_DISCOUNTS: {
      return {
        ...state,
        hasDiscounts: payload.hasDiscounts,
      };
    }
    default:
      return state;
  }
};

export default supplierDiscountsReducer;
